import {ChangeDetectionStrategy, Component, DestroyRef, OnInit, computed, inject, signal} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {MatIconModule} from '@angular/material/icon';
import {Router} from '@angular/router';
import {HypecastAuthenticationService} from '@app/shared/authentication/services/authentication.service';
import {UserAvatarComponent} from '@app/shared/components/user-avatar/user-avatar.component';
import {__} from '@app/shared/functions/object.functions';
import {Tenant} from '@app/shared/models/classes/Tenant';
import {User} from '@app/shared/models/classes/User';
import {ITenantService} from '@app/shared/services/itenant.service';

@Component({
  selector: 'hypecast-header',
  imports: [MatIconModule, UserAvatarComponent],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent implements OnInit {
  protected readonly user = signal<User | null>(null);
  protected readonly companyLogoUrl = signal('assets/logos/HYPECASTdefault.svg');
  protected readonly userAvatarUrl = computed(() => this.user()?.profilePictureLarge || null);

  private readonly tenantService = inject(ITenantService);
  private readonly authenticationService = inject(HypecastAuthenticationService);
  private readonly router = inject(Router);
  private readonly destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    this.companyLogoUrl.set(this.getCompanyLogo(this.tenantService.getTenant()));

    this.authenticationService.credentials$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((credentials) => this.user.set(credentials?.user ?? null));
  }

  protected navigateHome(): void {
    void this.router.navigate(['/home']);
  }

  protected navigateToSearch(): void {
    void this.router.navigate(['/discover']);
  }

  protected navigateToProfile(): void {
    void this.router.navigate(['/profile']);
  }

  protected useFallbackLogo(): void {
    this.companyLogoUrl.set('assets/logos/HYPECASTdefault.svg');
  }

  private getCompanyLogo(tenant: Tenant): string {
    if (!__.IsNullOrUndefinedOrEmpty(tenant?.companyLogoUrl)) {
      return tenant.companyLogoUrl;
    }
    if (!__.IsNullOrUndefinedOrEmpty(tenant?.logoUrl)) {
      return tenant.logoUrl;
    }
    return 'assets/logos/HYPECASTdefault.svg';
  }
}
